export default function PageHeader({ title, description, actions, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6"
    >
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-500 mt-1 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
